import "photoswipe/style.css";

import PhotoSwipeLightbox from "photoswipe/lightbox";

import type {MaybeRef} from "vue";
import {onMounted, onUnmounted, ref, unref} from "vue";

type LightBoxParameters = ConstructorParameters<typeof PhotoSwipeLightbox>[0];

export function useGallery({
	lightBoxParameters,
	onInit = undefined,
}: {
	lightBoxParameters: MaybeRef<LightBoxParameters>;
	onInit?: (pswp: PhotoSwipeLightbox) => void;
}) {
	const img = useImage();

	const lightBox = ref<PhotoSwipeLightbox>();
	const thumbnailsByMedia = ref<Record<string, string>>({});

	function runLightBox() {
		lightBox.value = new PhotoSwipeLightbox(unref(lightBoxParameters));
		if (onInit) {
			onInit(lightBox.value);
		}
		lightBox.value.init();
	}

	function getImageSourceSet(url: string) {
		return img.getSizes(url, {
			sizes: "xs:90vw sm:90vw md:90vw lg:90vw xl:90vw 2xl:90vw",
		}).srcset;
	}

	onMounted(() => {
		runLightBox();
	});

	onUnmounted(() => {
		lightBox.value?.destroy();
	});

	return {
		lightBox,
		thumbnailsByMedia,
		getImageSourceSet,
	};
}
